import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/client';
import './ConfiguracaoPremiosPontos.css';

const ConfiguracaoPremiosPontos = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [config, setConfig] = useState({
    pontos_por_posicao: {},
    pontos_padrao: 3,
    percentuais_premios: {},
    valores_fixos_premios: {},
    valor_minimo_premios_fixos: 1500.00,
    modo_envio_imagens: 'personalizado',
  });

  useEffect(() => {
    carregarConfiguracao();
  }, []);

  const carregarConfiguracao = async () => {
    try {
      setLoading(true);
      const response = await api.get('/configuracao/premios-pontos');
      setConfig(response.data);
    } catch (error) {
      console.error('Erro ao carregar configuração:', error);
      alert('Erro ao carregar configuração. Usando valores padrão.');
    } finally {
      setLoading(false);
    }
  };

  const handlePontosPosicaoChange = (posicao, valor) => {
    const pontos = parseInt(valor);
    if (!isNaN(pontos) && pontos >= 0) {
      const novosPontos = { ...config.pontos_por_posicao };
      if (pontos === 0) {
        delete novosPontos[posicao];
      } else {
        novosPontos[posicao] = pontos;
      }
      setConfig({ ...config, pontos_por_posicao: novosPontos });
    }
  };

  const handlePontosPadraoChange = (e) => {
    const valor = parseInt(e.target.value);
    if (!isNaN(valor) && valor >= 0) {
      setConfig({ ...config, pontos_padrao: valor });
    }
  };

  const handlePercentualPremioChange = (posicao, valor) => {
    const percentual = parseFloat(valor);
    if (!isNaN(percentual) && percentual >= 0 && percentual <= 100) {
      const novosPercentuais = { ...config.percentuais_premios };
      if (percentual === 0) {
        delete novosPercentuais[posicao];
      } else {
        novosPercentuais[posicao] = percentual;
      }
      setConfig({ ...config, percentuais_premios: novosPercentuais });
    }
  };

  const handleValorFixoPremioChange = (posicao, valor) => {
    const valorFixo = parseFloat(valor);
    if (!isNaN(valorFixo) && valorFixo >= 0) {
      const novosValores = { ...config.valores_fixos_premios };
      if (valorFixo === 0) {
        delete novosValores[posicao];
      } else {
        novosValores[posicao] = valorFixo;
      }
      setConfig({ ...config, valores_fixos_premios: novosValores });
    }
  };

  const adicionarPosicaoPontos = () => {
    const posicoes = Object.keys(config.pontos_por_posicao).map(Number).sort((a, b) => a - b);
    const proximaPosicao = posicoes.length > 0 ? Math.max(...posicoes) + 1 : 1;
    const novosPontos = { ...config.pontos_por_posicao, [proximaPosicao]: 0 };
    setConfig({ ...config, pontos_por_posicao: novosPontos });
  };

  const removerPosicaoPontos = (posicao) => {
    const novosPontos = { ...config.pontos_por_posicao };
    delete novosPontos[posicao];
    setConfig({ ...config, pontos_por_posicao: novosPontos });
  };

  const adicionarPosicaoPercentual = () => {
    const posicoes = Object.keys(config.percentuais_premios).map(Number).sort((a, b) => a - b);
    const proximaPosicao = posicoes.length > 0 ? Math.max(...posicoes) + 1 : 1;
    const novosPercentuais = { ...config.percentuais_premios, [proximaPosicao]: 0 };
    setConfig({ ...config, percentuais_premios: novosPercentuais });
  };

  const removerPosicaoPercentual = (posicao) => {
    const novosPercentuais = { ...config.percentuais_premios };
    delete novosPercentuais[posicao];
    setConfig({ ...config, percentuais_premios: novosPercentuais });
  };

  const adicionarPosicaoValorFixo = () => {
    const posicoes = Object.keys(config.valores_fixos_premios).map(Number).sort((a, b) => a - b);
    const proximaPosicao = posicoes.length > 0 ? Math.max(...posicoes) + 1 : 4;
    const novosValores = { ...config.valores_fixos_premios, [proximaPosicao]: 0 };
    setConfig({ ...config, valores_fixos_premios: novosValores });
  };

  const removerPosicaoValorFixo = (posicao) => {
    const novosValores = { ...config.valores_fixos_premios };
    delete novosValores[posicao];
    setConfig({ ...config, valores_fixos_premios: novosValores });
  };

  const handleValorMinimoChange = (e) => {
    const valor = parseFloat(e.target.value);
    if (!isNaN(valor) && valor >= 0) {
      setConfig({ ...config, valor_minimo_premios_fixos: valor });
    }
  };

  const handleSalvar = async () => {
    try {
      setSaving(true);
      await api.put('/configuracao/premios-pontos', config);
      alert('Configuração salva com sucesso!');
      await carregarConfiguracao();
    } catch (error) {
      console.error('Erro ao salvar configuração:', error);
      const errorMessage = error.response?.data?.message || 'Erro ao salvar configuração. Verifique os dados e tente novamente.';
      alert(errorMessage);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="configuracao-premios-pontos-container">
        <div className="loading">Carregando configuração...</div>
      </div>
    );
  }

  const posicoesPontos = Object.keys(config.pontos_por_posicao).map(Number).sort((a, b) => a - b);
  const posicoesPercentuais = Object.keys(config.percentuais_premios).map(Number).sort((a, b) => a - b);
  const posicoesValoresFixos = Object.keys(config.valores_fixos_premios).map(Number).sort((a, b) => a - b);
  const somaPercentuais = Object.values(config.percentuais_premios).reduce((acc, val) => acc + parseFloat(val || 0), 0);

  return (
    <div className="configuracao-premios-pontos-container">
      <div className="configuracao-header">
        <h1>🏆 Configuração de Prêmios e Pontos</h1>
        <button className="btn-voltar" onClick={() => navigate('/admin')}>
          ← Voltar
        </button>
      </div>

      <div className="configuracao-content">
        <div className="config-section">
          <h2>📊 Pontuação por Posição</h2>
          <p className="info-text">
            Configure quantos pontos cada posição no ranking recebe. 
            Posições não especificadas receberão os pontos padrão.
          </p>
          <div className="pontos-padrao-input">
            <label>
              Pontos Padrão (para posições não especificadas):
              <input
                type="number"
                min="0"
                step="1"
                value={config.pontos_padrao}
                onChange={handlePontosPadraoChange}
              />
            </label>
          </div>
          <div className="posicoes-grid">
            {posicoesPontos.map(posicao => (
              <div key={posicao} className="posicao-item">
                <label>
                  {posicao}º lugar:
                  <input
                    type="number"
                    min="0"
                    step="1"
                    value={config.pontos_por_posicao[posicao] || 0}
                    onChange={(e) => handlePontosPosicaoChange(posicao, e.target.value)}
                  />
                </label>
                <button 
                  className="btn-remover" 
                  onClick={() => removerPosicaoPontos(posicao)}
                  title="Remover posição"
                >
                  ×
                </button>
              </div>
            ))}
            <button className="btn-adicionar" onClick={adicionarPosicaoPontos}>
              + Adicionar Posição
            </button>
          </div>
        </div>

        <div className="config-section">
          <h2>💰 Distribuição de Prêmios (Top 3)</h2>
          <p className="info-text">
            Configure os percentuais da <strong>premiação total</strong> que serão distribuídos para as 3 primeiras posições.
            <br />
            <strong>Importante:</strong> A premiação total é calculada como: <strong>Total Arrecadado - Percentual da Caixinha</strong>.
            <br />
            Os percentuais configurados aqui são aplicados sobre o <strong>valor da premiação total</strong>, não sobre o total arrecadado.
            <br />
            <strong>Exemplo:</strong> Se o Total Arrecadado for R$ 200,00 e a Caixinha for 32%, a Premiação Total será R$ 136,00.
            Se o 1º lugar estiver configurado para 50%, ele receberá R$ 68,00 (50% de R$ 136,00).
          </p>
          {somaPercentuais > 100 && (
            <div className="warning-box">
              ⚠️ A soma dos percentuais ({somaPercentuais.toFixed(2)}%) ultrapassa 100%!
            </div>
          )}
          <div className="posicoes-grid">
            {posicoesPercentuais.map(posicao => (
              <div key={posicao} className="posicao-item">
                <label>
                  {posicao}º lugar:
                  <input
                    type="number"
                    min="0"
                    max="100"
                    step="0.01"
                    value={config.percentuais_premios[posicao] || 0}
                    onChange={(e) => handlePercentualPremioChange(posicao, e.target.value)}
                  />
                  <span className="percent-symbol">%</span>
                </label>
                <button 
                  className="btn-remover" 
                  onClick={() => removerPosicaoPercentual(posicao)}
                  title="Remover posição"
                >
                  ×
                </button>
              </div>
            ))}
            <button className="btn-adicionar" onClick={adicionarPosicaoPercentual}>
              + Adicionar Posição
            </button>
          </div>
        </div>

        <div className="config-section">
          <h2>💵 Valores Fixos de Prêmios (4º em diante)</h2>
          <p className="info-text">
            Configure valores fixos de prêmios para posições a partir do 4º lugar.
            <br />
            <strong>Importante:</strong> Estes prêmios fixos só serão ativados se o <strong>Total Arrecadado</strong> da rodada for igual ou superior ao <strong>Valor Mínimo</strong> configurado abaixo.
            <br />
            Se o total arrecadado for menor que o valor mínimo, apenas o Top 3 receberá prêmios conforme os percentuais configurados.
          </p>
          <div className="valor-minimo-input">
            <label>
              Valor Mínimo para Ativar Prêmios Fixos:
              <span className="currency-symbol">R$</span>
              <input
                type="number"
                min="0"
                step="0.01"
                value={config.valor_minimo_premios_fixos || 1500.00}
                onChange={handleValorMinimoChange}
              />
            </label>
            <p className="info-text" style={{ marginTop: '10px', fontSize: '0.9rem' }}>
              Exemplo: Se configurar R$ 1.500,00, os prêmios fixos (4º-9º) só serão pagos se o total arrecadado da rodada for ≥ R$ 1.500,00.
            </p>
          </div>
          <div className="posicoes-grid">
            {posicoesValoresFixos.map(posicao => (
              <div key={posicao} className="posicao-item">
                <label>
                  {posicao}º lugar:
                  <span className="currency-symbol">R$</span>
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    value={config.valores_fixos_premios[posicao] || 0}
                    onChange={(e) => handleValorFixoPremioChange(posicao, e.target.value)}
                  />
                </label>
                <button 
                  className="btn-remover" 
                  onClick={() => removerPosicaoValorFixo(posicao)}
                  title="Remover posição"
                >
                  ×
                </button>
              </div>
            ))}
            <button className="btn-adicionar" onClick={adicionarPosicaoValorFixo}>
              + Adicionar Posição
            </button>
          </div>
        </div>

        <div className="config-section">
          <h2>📸 Modo de Envio de Imagens no WhatsApp</h2>
          <p className="info-text">
            Escolha como as imagens serão enviadas quando um nocaute ou eliminação for registrado.
          </p>
          <div className="modo-envio-container">
            <label className="modo-envio-option">
              <input
                type="radio"
                name="modo_envio_imagens"
                value="personalizado"
                checked={config.modo_envio_imagens === 'personalizado'}
                onChange={(e) => setConfig({ ...config, modo_envio_imagens: e.target.value })}
              />
              <div className="modo-envio-content">
                <strong>🎨 Personalizado</strong>
                <p>Usa as imagens que cada jogador cadastrou e foram aprovadas pelo admin.</p>
              </div>
            </label>
            <label className="modo-envio-option">
              <input
                type="radio"
                name="modo_envio_imagens"
                value="aleatorio"
                checked={config.modo_envio_imagens === 'aleatorio'}
                onChange={(e) => setConfig({ ...config, modo_envio_imagens: e.target.value })}
              />
              <div className="modo-envio-content">
                <strong>🎲 Aleatório</strong>
                <p>Usa imagens aleatórias do banco de imagens do admin (você pode fazer upload na página de Imagens Aleatórias).</p>
              </div>
            </label>
          </div>
        </div>

        <div className="config-actions">
          <button 
            className="btn-salvar" 
            onClick={handleSalvar}
            disabled={saving || somaPercentuais > 100}
          >
            {saving ? 'Salvando...' : '💾 Salvar Configuração'}
          </button>
        </div>

        <div className="config-warning">
          <h3>⚠️ Atenção</h3>
          <ul>
            <li>As alterações nesta tela afetarão <strong>todas as rodadas futuras</strong>.</li>
            <li>Rodadas já fechadas <strong>não serão alteradas</strong>.</li>
            <li>Certifique-se de que os valores estão corretos antes de salvar.</li>
            <li>A soma dos percentuais de prêmios não pode ultrapassar 100%.</li>
            <li>Posições não especificadas receberão os pontos padrão ou prêmio R$ 0,00.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ConfiguracaoPremiosPontos;
